import { REQUIREMENTS } from 'legacy/constants/requirements'

/**
 * Get Requirements for a load
 * @param {any} load - Load Object
 * @returns {Array<{type: string, params?: any}>} requirements - Load requirements each with type and optional params
 */
function getRequirementsFromLoad(load) {
  let loadRequirements = []

  // Requirements on the root of the load object
  if (load.team_driver) loadRequirements.push({ type: 'team_driver' })
  if (load.requirements?.dunnage) loadRequirements.push({ type: 'dunnage' })

  // Requirements that have parameters
  if (load.requirements?.tarp) {
    const { tarp } = load.requirements
    loadRequirements.push({ type: 'tarp', params: tarp })
  }

  // Requirements for each stop - de-duplicated
  const stopRequirements = load.stops.reduce((acc, stop) => [...acc, ...stop.requirements], [])
  const uniqueStopRequirements = Array.from(new Set(stopRequirements))
  uniqueStopRequirements.forEach(stopRequirement => {
    loadRequirements.push({ type: stopRequirement })
  })

  return loadRequirements.sort((a, b) => {
    const requirementA = REQUIREMENTS[a.type]
    const requirementB = REQUIREMENTS[b.type]
    if (requirementA && requirementB) {
      return requirementA.order - requirementB.order
    }
    return 0
  })
}

export { getRequirementsFromLoad }
